// Suppress ResizeObserver loop error
const debounce = (func, wait) => {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};

const originalError = console.error;
console.error = debounce((...args) => {
  if (args[0]?.includes?.('ResizeObserver loop')) {
    return;
  }
  originalError(...args);
}, 100);